
export const STUDIO_SESSION_COOKIE_DEV = 'doorman-vst_signin-services-dev';
export const STUDIO_SESSION_COOKIE_PROD = 'doorman-vst_signin-services';
export const DUPLICATE_PRODUCT_NAME_API_ERROR = "response.duplicate.product";
export const FILE_SIZE_EXCEEDS_LIMIT_ERROR = "response.file.size.exceeds.limit";
export const INVALID_FILE_CONTENT_TYPE_ERROR = "response.invalid.file.content.type"

export const ROUTES = {
  AUTH: "/",
  PROJECTS: "/projects",
  PRODUCTS: "/projects/:projectId",
  FOUR_OH_FOUR: "/error/404",
  FIVE_HUNDRED: "/error/unknown",
  FEATURE_UPDATES: "/feature-updates"
};

export const KEYCODES = {
  ENTER: 13,
  ESCAPE: 27
}

export const PRODUCT_STATUS = {
  ACTIVE: "Active",
  DUPLICATION_IN_PROGRESS: "Duplication In Progress",
  CONVERSION_IN_PROGRESS: "Conversion In Progress",
  CONVERSION_FAILED: "Conversion Failed",
  TOC_LOCKED: "TOC Locked",
  IMPORT_IN_PROGRESS: "Import in Progress"
};

export const recaptchaHtmlId = "signin-recaptcha";

export const DEFAULT_REQUEST_OPTIONS = {
  hideLoader: false
};

export const COLORS = {
  WHITE: "WHITE"
};

export const PRODUCT_FILTER_PREFIX = "product-filter-";
export const FILE_EXTENSIONS = {
  PDF: ".pdf",
  ZIP: ".zip"
};

export const INPUT_FILE_TYPES = {
  ZIP: "application/zip",
  PDF: "application/pdf"
};
export const STUDIO_DISABLE_LIBRARIES_LINK = "STUDIO_DISABLE_LIBRARIES_LINK";
export const SORT_ATTRIBUTE = {
  lastEdited: {
    key: "lastEdited",
    displayVal: "Last Edited"
  },
  a_z: {
    key: "A_Z",
    displayVal: "A - Z"
  },
  z_a: {
    key: "Z_A",
    displayVal: "Z - A"
  }
};
export const IMPORT_POLL_INTERVAL = 20000;
export const MOCK_IMPORT_FILE_PROGRESS_TIME_THRESHOLD = 5000;
export const MOCK_IMPORT_FILE_PROGRESS_INTERVAL = 350;

